export const IMAGE_JPEG_MIME_TYPE = 'image/jpeg';
export const IMAGE_PNG_MIME_TYPE = 'image/png';
export const PDF_MIME_TYPE = 'application/pdf';
export const ALL_IMAGE_MIME_TYPE = 'image/*';
export const PDF_EXTENSION = 'pdf';

export const IMAGE_MIME_TYPES = [IMAGE_JPEG_MIME_TYPE, IMAGE_PNG_MIME_TYPE];
export const IMAGE_FILE_UPLOADER_ACCEPTED_TYPES = `${IMAGE_JPEG_MIME_TYPE}, ${IMAGE_PNG_MIME_TYPE}`;
export const ADMIN_FILE_UPLOADER_ACCEPTED_TYPES = `${IMAGE_JPEG_MIME_TYPE}, ${IMAGE_PNG_MIME_TYPE}, ${PDF_MIME_TYPE}`;

export const DZ_IMAGE_JPEG_MIME_TYPE = {'image/jpeg': ['.jpeg', '.jpg']};
export const DZ_IMAGE_PNG_MIME_TYPE = {'image/png': ['.png']};
export const DZ_PDF_MIME_TYPE = {'application/pdf' : ['.pdf']};
export const DZ_ALL_IMAGE_MIME_TYPE =  {
    'image/*': ['.jpeg','.jpg', '.png']
};
export const DZ_IMAGE_MIME_TYPES = DZ_ALL_IMAGE_MIME_TYPE;
export const DZ_IMAGE_FILE_UPLOADER_ACCEPTED_TYPES = DZ_ALL_IMAGE_MIME_TYPE;
export const DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES = {
    'image/*': ['.jpeg','.jpg', '.png'],
    'application/pdf' : ['.pdf']
};

export const DZ_ADMIN_FILE_UPLOADER_XLSX_ACCEPTED_TYPES = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
};
